import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  ThumbUp as ThumbUpIcon,
  ThumbDown as ThumbDownIcon,
  ThumbUpOutlined as ThumbUpOutlinedIcon,
  ThumbDownOutlined as ThumbDownOutlinedIcon,
} from '@material-ui/icons'
import { Box, IconButton, Paper, Typography } from '@material-ui/core'

import { ConfirmationDialog } from './components'

import useStyles from './styles'
import constants from 'constants/index'

import DaiLogo from 'images/dai-simple-logo-white.png'

const FeedbackAlert = ({
  title = 'Como foi sua interação com a DAI?',
  subTitle = 'Sua opinião é importante para melhorarmos a qualidade das interações com a DAI.',
  handleSubmit,
}) => {
  const [open, setOpen] = useState(false)
  const [feedback, setFeedback] = useState(null)
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(null)

  const classes = useStyles()

  const { POSITIVE_FEEDBACK_VARIANT, NEGATIVE_FEEDBACK_VARIANT } =
    constants.dai.general

  const isPositiveFeedback = feedbackSubmitted === POSITIVE_FEEDBACK_VARIANT
  const isNegativeFeedback = feedbackSubmitted === NEGATIVE_FEEDBACK_VARIANT

  const handlePositiveFeedback = () => {
    setFeedback(POSITIVE_FEEDBACK_VARIANT)
    setOpen(true)
  }

  const handleNegativeFeedback = () => {
    setFeedback(NEGATIVE_FEEDBACK_VARIANT)
    setOpen(true)
  }

  return (
    <Paper variant="outlined" className={classes.container}>
      <Box className={classes.baseBox} justifyContent="space-between">
        <Box className={classes.baseBox}>
          <img width={80} height="auto" src={DaiLogo} alt="Logo da DAI" />
          <Box display="flex" flexDirection="column">
            <Typography variant="h6">{title}</Typography>
            <Typography variant="body2">{subTitle}</Typography>
          </Box>
        </Box>
        <Box>
          <IconButton
            className={classes.thumbsUpIcon}
            onClick={handlePositiveFeedback}
          >
            {isPositiveFeedback ? (
              <ThumbUpIcon fontSize="small" />
            ) : (
              <ThumbUpOutlinedIcon fontSize="small" />
            )}
          </IconButton>
          <IconButton
            className={classes.thumbsDownIcon}
            onClick={handleNegativeFeedback}
          >
            {isNegativeFeedback ? (
              <ThumbDownIcon fontSize="small" />
            ) : (
              <ThumbDownOutlinedIcon fontSize="small" />
            )}
          </IconButton>
        </Box>
      </Box>
      {open && (
        <ConfirmationDialog
          open={open}
          setOpen={setOpen}
          feedback={feedback}
          setFeedbackSubmitted={setFeedbackSubmitted}
          handleSubmit={handleSubmit}
        />
      )}
    </Paper>
  )
}

FeedbackAlert.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
}

export default FeedbackAlert
